// import '../../style/index.scss';
import Booker from "./components";

export default Booker;
// test build
// force prod
// salete de build
